import useSvgImages, { SvgDefinition } from '../../../utils/useSvgImages';
import startSvg from '../../../utils/svgDefinitions/startSvg';
import endSvg from '../../../utils/svgDefinitions/endSvg';
import startEndSvg from '../../../utils/svgDefinitions/startEndSvg';
import handleSvg from '../../../utils/svgDefinitions/handleSvg';
import { useSelector } from '../../../redux';
import InactivePolylines from './InactivePolylines';
import Markers from './Markers';
import ActivePolyline from './ActivePolyline';
import HoveredPolyline from './HoveredPolyline';

const svgDefinitions: SvgDefinition[] = [startSvg, endSvg, startEndSvg, handleSvg];

const Segments = () => {
  const { segments, isEditing } = useSelector(state => ({
    segments: state.customRoute.route.segments,
    isEditing: state.customRoute.isEditing
  }));

  // Load images that will be used in Segment components so that the components don't all load the same images
  const { imagesAreLoaded } = useSvgImages(svgDefinitions);

  if (!segments || !imagesAreLoaded) {
    return null;
  }

  return (
    <>
      <InactivePolylines />
      <ActivePolyline />
      {!isEditing && <HoveredPolyline />}
      <Markers />
    </>
  );
};

export default Segments;
